<template>
  <div
    :style="getDisplay == 0 ? 'min-height: calc(100vh - 136px)' : ''"
    v-loading="homeLoading"
    :element-loading-text="$t('拼命加载中')"
  >
    <div>
      <div class="title" v-if="getDisplay == 0">
        <div class="title--newFont">
          <span>{{ $t("工序委外单详情") }}</span>
        </div>
        <div style="text-align: right">
          <el-button class="btnTwo" size="small" @click="backHome">{{
            $t("返回")
          }}</el-button>
        </div>
      </div>
      <hr />
      <!-- 内容 -->
      <div class="section-title">丨{{ $t("基本信息") }}</div>
      <div style="margin-top: 10px">
        <el-descriptions
          direction="horizontal"
          size="small"
          :column="4"
          border
          :label-style="labelStyle"
          :content-style="contentStyle"
        >
          <el-descriptions-item>
            <template slot="label">{{ $t("工序委外单号") }} </template>
            <span>{{ singleData.processOutsourcingDocNumber }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("全局搜索码") }}</template>
            <span>{{ singleData.globalSearchNumber }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("生产单编号") }}</template>
            <span>{{ singleData.baseProduceDocNumber }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("创建日期") }}</template>
            <span class="nowrap-text">{{ singleData.createTime }}</span>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="section-title">丨{{ $t("委外信息") }}</div>
      <div style="margin-top: 10px">
        <el-descriptions
          direction="horizontal"
          size="small"
          :column="4"
          border
          :label-style="labelStyle"
          :content-style="contentStyle"
        >
          <el-descriptions-item>
            <template slot="label">{{ $t("工序编号") }}</template>
            <span>{{ singleData.baseProcessNumber }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("工序名称") }}</template>
            <span>{{ singleData.baseProcessName }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("委外商名称") }}</template>
            <span>{{ singleData.baseSupplierName }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("委外数量") }}</template>
            <span>{{ singleData.baseOutsourcingQuantity }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("委外单价") }}</template>
            <span>{{ singleData.baseMaterialUnitprice }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("委外总价") }}</template>
            <span>{{ singleData.baseMaterialTotalprice }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("生产模式") }}</template>
            <span>{{
              singleData.produceType == 0 ? $t("自由模式") : $t("严谨模式")
            }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("备注") }}</template>
            <span>{{ singleData.remark }}</span>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="section-title">丨{{ $t("收货产品") }}</div>
      <div style="margin-top: 10px">
        <myHtml
          :id="'myTableOne'"
          :columnType="'columnIndex'"
          :list="productList"
          :titleList="productTitleList"
        ></myHtml>
      </div>
      <div class="section-title">丨{{ $t("发料清单") }}</div>
      <div style="margin-top: 10px">
        <myHtml
          :id="'myTableTwo'"
          :columnType="'columnIndex'"
          :list="materialList"
          :titleList="materialTitleList"
        ></myHtml>
      </div>
    </div>
    <!-- 产品溯源 -->
    <el-dialog
      :visible.sync="dialogState.show4"
      :close-on-click-modal="false"
      class="dialog"
      :title="$t('产品溯源')"
      width="90%"
      append-to-body
      @close="dialogClose"
    >
      <div>
        <myTraceability
          v-if="dialogState.show4"
          :batchNumber="singleData.batchNumber"
        ></myTraceability>
      </div>
    </el-dialog>
    <myOrderAdd
      v-if="htmlDataDialogState.show1"
      :visible="htmlDataDialogState.show1"
      :homeIndex="homeIndex"
      :routeQuery="routeLevelQuery"
      :routeType="routeType"
      @htmlDataDialogClose="htmlDataDialogClose"
    ></myOrderAdd>
  </div>
</template>
<script>
import {
  divFloat,
  mulFloat,
  accAdd,
  subFloat,
  year,
  month,
  day,
  _debounce,
} from "@/utils/myUtils";
import { processOutsourcing_view } from "@/api/myController/outsourcing";
export default {
  props: {
    // 页面传进来判断的值
    routeType: {
      type: Array,
      default: undefined,
    },
    // 页面传进来的值
    routeQuery: {
      default: () => ({}),
    },
    // 内容
    singleData: {
      default: () => ({}),
    },
    //
    getDisplay: {
      type: Number,
      default: 0,
    },
  },
  components: {},
  data() {
    return {
      processOutsourcing_view,
      labelStyle: {
        "text-align": "center",
        "font-weight": "600",
        "min-width": "110px",
        "word-break": "keep-all",
        "white-space": "nowrap",
        height: "41px",
      },
      contentStyle: {
        "min-width": "160px",
        "word-break": "keep-all",
        "white-space": "nowrap",
      },
      hrefProData: {},
      homeLoading: false,
      dialogState: {
        show1: false,
        show2: false,
        show3: false,
        show4: false,
      },
      htmlDataDialogState: {
        show1: false,
      },
      dialogData: {},
      productList: [],
      productTitleList: [
        {
          id: 1,
          name: this.$t("收货产品"),
          value: "baseMaterialName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 180,
        },
        {
          id: 1,
          name: this.$t("来源工序"),
          value: "baseProcessName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 180,
        },
        {
          id: 1,
          name: this.$t("规格"),
          value: "specifications",
          fixedState: false,
          isShow: true,
          dataType: "textList",
          canEdit: false,
          width: 220,
        },
        {
          id: 1,
          name: this.$t("数量"),
          value: "baseOutsourcingFinishedQuantity",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 180,
        },
        {
          id: 1,
          name: this.$t("备注"),
          value: "remark",
          fixedState: false,
          isShow: true,
          dataType: "textarea",
          canEdit: false,
        },
      ],
      materialList: [],
      materialTitleList: [
        {
          id: 1,
          name: this.$t("物料编号"),
          value: "baseMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 180,
        },
        {
          id: 1,
          name: this.$t("物料名称"),
          value: "baseMaterialName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 180,
        },
        {
          id: 1,
          name: this.$t("物料规格"),
          value: "specifications",
          fixedState: false,
          isShow: true,
          dataType: "textList",
          canEdit: false,
          width: 220,
        },
        {
          id: 1,
          name: this.$t("客户料号"),
          value: "baseCustomerMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 180,
        },
        {
          id: 1,
          name: this.$t("数量"),
          value: "baseRequisitionQuantity",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 180,
        },
        {
          id: 1,
          name: this.$t("备注"),
          value: "remark",
          fixedState: false,
          isShow: true,
          dataType: "textarea",
          canEdit: false,
        },
      ],
    };
  },
  created() {
    this.initData();
  },
  methods: {
    $t(val) {
      return val;
    },
    // 初始化
    initData() {
      if (this.getDisplay == 0) {
        this.getList();
      }
    },
    //
    getList() {
      this.homeLoading = true;
      processOutsourcing_view({
        processOutsourcingDocId: this.routeQuery.processOutsourcingDocId,
      }).then((res) => {
        res.data.data.receiveList.forEach((item) => {
          item.baseProcessName = res.data.data.baseProcessName;
          try {
            item.specifications = JSON.parse(item.baseSpecgroupDesc);
          } catch (error) {
            item.specifications = [];
          }
        });
        res.data.data.requisitionList.forEach((item) => {
          try {
            item.specifications = JSON.parse(item.baseSpecgroupDesc);
          } catch (error) {
            item.specifications = [];
          }
        });
        this.productList = res.data.data.receiveList;
        this.materialList = res.data.data.requisitionList;
        this.singleData = res.data.data;
        this.homeLoading = false;
      });
    },
    htmlDataDialogClose() {
      this.htmlDataDialogState.show1 = false;
      this.getList();
    },
    batchNumberClick() {
      this.dialogState.show4 = true;
    },
    dialogClose() {
      this.dialogState.show4 = false;
      this.dialogState.show2 = false;
      this.dialogState.show3 = false;
    },
    backHome() {
      this.$emit("backHome");
    },
  },
};
</script>
<style scoped>
.input {
  width: 100%;
}

.btnOne {
  background: #1476c3;
  border-color: #1476c3;
  color: white;
}

.title {
  display: flex;
  position: relative;
  margin-bottom: 10px;
  align-items: center;
  justify-content: space-between;
}

.title--newFont {
  color: #1476c3;
  font-size: 22px;
  font-weight: bold;
}

.section-title {
  color: #1476c3;
  font-weight: 800;
  font-size: 16px;
  margin-top: 10px;
}

.nowrap-text {
  white-space: nowrap;
  word-break: keep-all;
}

.title--button {
  position: absolute;
  margin-left: 1px;
  margin-top: 0.1%;
}

.turnToPointer {
  color: #1476c3;
  cursor: pointer;
}
</style>
